import TCIcon from './TCIcon.view';

export default TCIcon;
